import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import "./LogoutModal.css";

const LogoutModal = (props) => {
    return (
        <Modal className="LogoutModal" show={props.showLogoutModal} onHide={props.handleCloseLogout} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Logout</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <h3>Are you sure you want to log out?</h3>


                <div className='btn_holder'>
                    <Button className='no_button' onClick={props.handleCloseLogout}>
                        No
                    </Button>
                    <Button className="logout_confrim_btn" onClick={() => {
                        props.handleLogout();
                        props.handleCloseLogout();
                    }}>
                        Yes
                    </Button>
                </div>

            </Modal.Body>


        </Modal>
    )
}

export default LogoutModal
